import React from 'react';

import PersonIcon from '@mui/icons-material/Person';
import { Container, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { CardContainer, HeaderContainer, TitleIcon } from 'common/components';

import DataForm from './components/DataForm';

const ProfileContainer = () => {
    const { t } = useTranslation();
    return (
        <Container maxWidth="">
            <HeaderContainer>
                <Typography variant="h4" gutterBottom>
                    <TitleIcon icon={<PersonIcon />} title={t('My profile')} />
                </Typography>
            </HeaderContainer>

            <Grid container>
                <Grid size={18}>
                    <CardContainer title={t('General information')}>
                        <DataForm />
                    </CardContainer>
                </Grid>
            </Grid>
        </Container>
    );
};

ProfileContainer.propTypes = {};

export default ProfileContainer;
